define('Commercers_CustomFilter/js/filter',["uiComponent", "ko", "jquery", "jquery/ui", "Magento_Ui/js/modal/modal"], (
    function (e, t, $, i, a) {
        "use strict";
        return e.extend({
            initialize: function () {
                this._super()
            },
            clickFilter: function (e, t) {
                var i = $(t.target).next();
                i.hasClass("active") ? (i.removeClass("active"), $(t.toElement).removeClass("parent-active")) : (i.addClass("active"), $(t.toElement).addClass("parent-active"))
            },
            openModal: function () {
                var e = {
                    type: "slide",
                    responsive: !0,
                    innerScroll: !0,
                    title: $.mage.__("Filters"),
                    modalClass: "modal-filter-right",
                    buttons: [{
                        text: $.mage.__("Close"),
                        class: "show-result",
                        click: function () {
                            this.closeModal()
                        }
                    }]
                };
                a(e, $(".filter-right")), $(".filter-right").modal("openModal")
            }
        })
    }
));

